import { theme } from '../../../themes';

export type TagData = {
  displayText: string;
  messageText: string;
  isGoodTag: boolean;
  showInputField?: boolean;
  labelInputText?: string;
};

export const otherDisplayText = 'Other';

export const ratingToGoodTag: { [key: number]: boolean } = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: true,
};

export const TagOptionsMap: { [key: string]: TagData } = {
  easyToFollow: {
    displayText: 'Easy to Follow',
    messageText: 'Thanks for your feedback!',
    isGoodTag: true,
  },
  helpful: {
    displayText: 'Helpful',
    messageText: `We're happy to hear that :)`,
    isGoodTag: true,
  },
  otherFiveStar: {
    displayText: otherDisplayText,
    messageText: `Thanks for your feedback. We'll make sure we keep doing the good stuff.`,
    isGoodTag: true,
    showInputField: true,
    labelInputText: 'Drop us a line and let us know what we did well!',
  },
  hardToFollow: {
    displayText: 'Hard to follow',
    messageText: `We want to make this right. Chat with a ${theme.expert.expertName} if you still have questions`,
    isGoodTag: false,
  },
  tooComplicated: {
    displayText: 'Too complicated',
    messageText: `Thanks for your feedback. Chat with a ${theme.expert.expertName} to find an easier answer.`,
    isGoodTag: false,
  },
  other: {
    displayText: otherDisplayText,
    messageText: `Thanks for your feedback. If you still have questions, chat with a ${theme.expert.expertName}. We’re ready to help.`,
    isGoodTag: false,
    showInputField: true,
    labelInputText: 'Drop us a line and tell us know what we can improve.',
  },
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/TagOptionsMap.ts